import { FieldMetaProps, useField } from 'formik';
import React from 'react';
import { isNil } from 'lodash';

interface ArrayLevelValidationMessageProps {
  name: string;
}

// ArrayLevelValidationMessage is intended for a Formik FieldArray field.
// This component will render validation errors that pertain to the array-level.
// For example, suppose we have a validation scheme like so:
//   { field: yup.array().of(SCHEMA).min(1, 'Must have one item') };
// ArrayLevelValidationMessage could render the validation error message for the `min`.
export function ArrayLevelValidationMessage<T>({ name }: ArrayLevelValidationMessageProps) {
  const [, fieldMetaProps] = useField<T>({ name });
  if (!isArrayLevelError(fieldMetaProps)) return null;

  return <p className={'text-red-600'}>{JSON.stringify(fieldMetaProps.error).slice(1, -1)}</p>;
}

interface FieldMetaPropsWithDefinedArrayLevelError<T> extends Omit<FieldMetaProps<T>, 'error' | 'touched'> {
  touched: true;
  error: string;
}

function isArrayLevelError<T>(
  fieldMetaProps: FieldMetaProps<T>
): fieldMetaProps is FieldMetaPropsWithDefinedArrayLevelError<T> {
  if (!fieldMetaProps.touched) {
    return false;
  }
  if (isNil(fieldMetaProps.error)) {
    return false;
  }
  return !Array.isArray(fieldMetaProps.error);
}
